/**
 * ProgressRing — SVG ring showing filled/total sections.
 */

interface ProgressRingProps {
  filled: number
  total: number
  size?: number
  strokeWidth?: number
}

export function ProgressRing({ filled, total, size = 28, strokeWidth = 3 }: ProgressRingProps) {
  const radius = (size - strokeWidth) / 2
  const circumference = 2 * Math.PI * radius
  const progress = total > 0 ? filled / total : 0
  const offset = circumference * (1 - progress)

  return (
    <div className="flex items-center gap-1.5">
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="var(--color-border-subtle)"
          strokeWidth={strokeWidth}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="var(--color-business)"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          className="transition-all duration-500"
        />
      </svg>
      <span className="text-xs text-text-secondary">
        {filled}/{total}
      </span>
    </div>
  )
}
